/* Glue around the design system's shell classes. Tokens only (stylelint enforces it). */

/* The landmark wrapper of the bottom bar hides together with the bar from 64em (1024 px). */
@media (min-width: 64em) {
  .bottomNav {
    display: none;
  }
}

/* A destination without a screen is a span (React Aria renders a disabled link without href as one) and the
   design system styles anchors only, so these two classes carry the measures of .sf-topnav a and
   .sf-bottomnav a, in the quiet ink of paper hints. */
.soonTop {
  display: inline-flex;
  align-items: center;
  gap: var(--sf-space-2);
  padding-inline: var(--sf-space-3);
  border-block: var(--sf-border-strong) solid transparent;
  color: var(--sf-ink-3);
  font-size: var(--sf-text-md);
  font-stretch: var(--sf-width-semi);
  font-weight: var(--sf-weight-medium);
  cursor: not-allowed;
}
.soonBottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sf-space-1);
  block-size: 100%;
  min-block-size: var(--sf-target-phone);
  padding-inline: var(--sf-space-0-5);
  color: var(--sf-ink-3);
  font-size: var(--sf-text-xs);
  font-stretch: var(--sf-width-semi);
  font-weight: var(--sf-weight-semibold);
  line-height: var(--sf-leading-snug);
  text-align: center;
  overflow-wrap: anywhere;
  cursor: not-allowed;
}

/* A notice at the top of the main area needs air under the top bar. */
.notice {
  padding-block-start: var(--sf-space-4);
}

/* A list of places (Mehr) or of areas to come (Einstellungen): titles with one line each. */
.linkList {
  display: grid;
  gap: var(--sf-space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}
.linkListTitle {
  font-weight: var(--sf-weight-semibold);
}
.linkListMeta {
  margin: 0;
  color: var(--sf-ink-2);
  font-size: var(--sf-text-sm);
}

/* A reading column: the text measure plus the slot's padding and the desk gutters. */
.readable {
  max-inline-size: calc(var(--sf-measure) + 2 * var(--sf-space-6) + 2 * var(--sf-gutter-desk));
}
@media (min-width: 64em) {
  .readable {
    padding-inline: var(--sf-gutter-desk);
  }
}
